import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './login.module.css';
import logoAuth from '../Images/logo.svg';

interface LocationState {
  email?: string;
  message?: string;
}

const UserNotProvisioned: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState;
  const queryParams = new URLSearchParams(location.search);

  // Prefer router state (in-app nav), fall back to query params (backend redirect).
  const email = state?.email || queryParams.get('email') || 'your email';
  const message =
    state?.message ||
    queryParams.get('message') ||
    'User not provisioned in the system';

  const handleBackToLogin = () => {
    // Clear any stored auth tokens
    localStorage.clear();
    navigate('/sign-in');
  };

  return (
    <section className={styles.section}>
      <div className={styles.signIn}>
        <header>
          <div className={styles.logo}>
            <img src={logoAuth} alt="logo" className={styles.user_img} />
          </div>
        </header>
        
        <div style={{ 
          textAlign: 'center', 
          padding: '20px',
          maxWidth: '500px',
          margin: '0 auto'
        }}>
          <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
            Access Denied
          </h2>
          
          <div style={{ 
            backgroundColor: '#fff3e0', 
            border: '1px solid #ffb74d',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px'
          }}>
            <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
              {message}
            </p>
            
            <p style={{ marginBottom: '10px' }}>
              The email address <strong>{email}</strong> has been authenticated 
              but is not yet provisioned in the ProPilot system.
            </p>
            
            <p>
              Please contact your system administrator to request access.
            </p>
          </div>

          <div style={{ 
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            padding: '15px',
            marginBottom: '20px'
          }}>
            <h4 style={{ marginBottom: '10px' }}>Administrator Contact:</h4>
            <p>Email: kyle.keith@profrac.com</p>
            <p>Please include the requested company access in your email.</p>
          </div>

          <button 
            onClick={handleBackToLogin}
            style={{
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 20px',
              cursor: 'pointer',
              fontSize: '16px',
              marginTop: '20px'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1565c0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#1976d2'}
          >
            Back to Login
          </button>
        </div>
      </div>
    </section>
  );
};

export default UserNotProvisioned;